"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawPoint = void 0;
var utils_1 = require("../../../utils");
var pointWidth = 12;
var pointHalfWidth = (0, utils_1.roundToInt)(pointWidth / 2);
var drawPoint = function (ctx, pos) {
    // ctx.fillRect(
    //   pos.x - pointHalfWidth,
    //   pos.y - pointHalfWidth,
    //   pointWidth,
    //   pointWidth
    // )
    ctx.beginPath();
    ctx.arc(pos.x, pos.y, pointHalfWidth, 0, Math.PI * 2, false);
    ctx.fill();
};
exports.drawPoint = drawPoint;
